<footer class="bg_black_high_emphasis" tabindex="0">

	<div class="container">

		<div class="flex_wrap gap_large">
			<div class="flex1">
				<img class="logo pointer margin_bottom_small" (click)="routerService.toHome()" src="/assets/img/logos/ecotopia_negative.svg">
	
				<a href="https://www.linkedin.com/company/ecotopia-in" target="_blank" class="social_media_icon inline_block margin_right_medium" aria-label="Instagram">
					<svg>
						<use href="/assets/img/icons/linkedin_icon.svg#linkedIn_icon"></use>
					</svg>
				</a>
				<a href="https://www.instagram.com/ecotopia.arg" target="_blank" class="social_media_icon inline_block" aria-label="LinkedIn">
					<svg>
						<use href="/assets/img/icons/instagram_icon.svg#instagram_icon"></use>
					</svg>
				</a>
			</div>
	
			<div class="column">
				<p>Acerca de</p>
				<a class="color_white_high_emphasis" [routerLink]="routerService.ABOUT_US">Quiénes somos</a>
				<a class="color_white_high_emphasis" [routerLink]="routerService.OUR_VALUES">Nuestros pilares</a>
				<a class="color_white_high_emphasis" [routerLink]="routerService.ECOTRENDS">Ecotrends</a>
				<a class="color_white_high_emphasis" (click)="contact.openDialog()" (keydown.enter)="contact.openDialog()" tabindex="0">Contacto</a>
			</div>
			<div class="column">
				<p>Ayuda</p>
				<a class="color_white_high_emphasis" [routerLink]="routerService.HELP_PURCHASE">Comprar</a>
				<a class="color_white_high_emphasis" [routerLink]="routerService.HELP_SALE">Vender</a>
				<a class="color_white_high_emphasis" [routerLink]="routerService.FAQ">Preguntas frecuentes</a>
			</div>
			<div class="column">
				<p>Legales</p>
				<a class="color_white_high_emphasis" [routerLink]="routerService.PRIVACY_POLICY">Políticas de privacidad</a>
				<a class="color_white_high_emphasis" [routerLink]="routerService.TERMS_AND_CONDITIONS">Términos y condiciones</a>
			</div>	
		</div>

		<hr>

		<div class="flex justify_content_space_between flex_xs_column">
			<p class="body2 color_black_inactive">
				@ {{ year }}
				<a [routerLink]="routerService.HOME" class="body2 color_black_inactive">Ecotopia</a>.
				Todos los derechos reservados
			</p>

			<p class="body2 color_black_inactive">
				Powered by
				<a href="https://tots.agency" target="_blank" class="tots_link body2 fw500">TOTS</a>
			</p>
		</div>

	</div>
</footer>